<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- NAME -->
        <FormItem prop="name" label="ФИО">
          <Input v-model="formData.name" placeholder="ФИО"/>
        </FormItem>

        <!-- INN -->
        <FormItem prop="inn" label="ИИН/БИН">
          <Input v-model="formData.inn" placeholder="ИИН/БИН"/>
        </FormItem>

        <!-- PHONE -->
        <FormItem prop="phone" :label="schema.phone.label">
          <Input v-model="formData.phone" :placeholder="schema.phone.label"/>
        </FormItem>

        <!-- EMAIL -->
        <FormItem prop="email" :label="schema.email.label">
          <Input v-model="formData.email" :placeholder="schema.email.label"/>
        </FormItem>

<!--        &lt;!&ndash; ADDRESS LEGAL &ndash;&gt;-->
<!--        <FormItem prop="address_legal" :label="schema.address_legal.label">-->
<!--          <Input-->
<!--            type="textarea"-->
<!--            v-model="formData.address_legal"-->
<!--            :placeholder="schema.address_legal.label"-->
<!--          />-->
<!--        </FormItem>-->

        <!-- BIRTH DATE -->
        <FormItem prop="birth_date">
          <DatePicker
            format="yyyy-MM-dd"
            type="date"
            split-panels
            placeholder="Дата рождения"
            style="width: 200px"
            :value="formData.birth_date"
            @on-change="setOrderDate"
          ></DatePicker>
        </FormItem>

        <!-- Gender -->
        <FormItem prop="gender" label="Пол">

          <Select v-model="formData.gender">
            <Option
              value="FEMALE"
            >Женский</Option>
            <Option
              value="MALE"
            >Мужской</Option>

          </Select>
        </FormItem>

        <!-- DEFAULT -->
<!--        <FormItem prop="default" :label="schema.default.label">-->
<!--          <i-switch v-model="formData.default"></i-switch>-->
<!--        </FormItem>-->
      </Form>
    </div>
    <div class="ls_drawer_footer" style="margin-top: 50px">
      <Button style="margin-right: 8px" @click="cancelAction()" type="error">
        <Icon type="md-close"/>
      </Button>
      <Button
        type="info"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      >
        <Icon type="md-checkmark"/>
      </Button>
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {BaseFormData} from "../../base/base_form_v2.js";

    let _app = BaseFormData();
    _app.data = function () {
        return {
            loading: true,
            baseRules: {
              inn: [
                {
                  type: 'string',
                  message: 'ИИН/БИН должен состоять из 12-ти цифр',
                  trigger: 'blur',
                  pattern: /^[0-9]{12}$/,
                  // length: 12
                }
              ],
              email: [
                {
                  type: 'email',
                  message: 'Неверный формат email',
                  trigger: 'blur'
                }
              ]
            },
            excludeFieldsRules: [],
            validForm: false,
            isChanged: false,

            formData: {
                name: "",
                inn: "",
                phone: "",
                email: "",
                birth_date: null,
                gender: ""

            },

            formDefaultInitData: {
                name: "",
                inn: "",
                phone: "",
                email: "",
                birth_date: null,
                gender: ""
            },

            formSelectOptions: {}
        };


    };

    _app.methods.setOrderDate = function (date_str) {
        this.formData.birth_date = date_str ? date_str : null;
    };


    export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/debtor/debtorForm.vue